/* pdp-pair.js (the item page run, B3): the recommended rows printed by snippets/pdp-pair.liquid.
   - shows the one .ip-pair-g per row that fits the picked colour (and size, on the band row), from the page's
     ip:variant event and window.ipVariant; a colour or size with no group hides the row;
   - only the open group is in the page; every other group waits in an inert <script type="text/template"
     class="ip-pair-t"> with the same data-ip-color / data-ip-size, and is built the first time a pick needs it
     (W2-fix, G4): it then gets the page's current variant, price and button state, and the same handlers;
   - on the band row, sets the paired band's variant from data-ip-vmap ("size:variantId|...") for the picked size;
   - keeps the paired cart line's hidden _rec property in step with the live checkboxes, and posts Add both itself
     so _rec reaches the cart line;
   - sends view_item_list (once per row, half on screen), select_item (every card tap) and select_item
     '<row>:add_both' (Add both with both pieces ticked) or '<row>:add_one' (the paired piece alone, this item
     unticked) through window.traxEmit only;
   - Sameera's picks (W2-picks, Dima's chain page): a tap on a .mk-pr pick marks it, swaps it into the total, the
     pendant line, Add both and the set-price text; every event names the pick (items[].pick, and pick on
     select_item). */
(function () {
  var root = document.getElementById('pdp-b');
  if (!root) return;
  var rows = [].slice.call(root.querySelectorAll('.ip-row'));
  if (!rows.length) return;

  var ipAttr = root.getAttribute('data-ip') || '';
  var cut = ipAttr.indexOf(':');
  var famBase = cut > -1 ? ipAttr.slice(0, cut) : ipAttr;
  var kind = cut > -1 ? ipAttr.slice(cut + 1) : '';

  function norm(s) { return String(s == null ? '' : s).replace(/^\s+|\s+$/g, '').toLowerCase(); }
  function emit(name, payload) { try { window.traxEmit && window.traxEmit(name, payload); } catch (e) {} }
  function rowOf(el) { return el.closest ? el.closest('.ip-row') : null; }
  function groupOf(el) { return el.closest ? el.closest('.ip-pair-g') : null; }
  function itemOf(a, i) {
    var it = { item_id: a.getAttribute('data-ip-item') || '', item_name: a.getAttribute('data-ip-iname') || '',
      price: (parseInt(a.getAttribute('data-ip-price'), 10) || 0) / 100, index: i };
    var pk = a.getAttribute('data-ip-pick');
    if (pk) it.pick = pk;
    return it;
  }
  function withPick(pl, a) { var pk = a && a.getAttribute('data-ip-pick'); if (pk) pl.pick = pk; return pl; }
  function payload(row, listId, items) {
    return { item_list_id: listId, item_list_name: row.getAttribute('data-ip-name') || '', fam: famBase, kind: kind, items: items };
  }
  /* the row's own groups: the open one(s) in the page and the ones still waiting in a template */
  function slots(row) {
    return [].slice.call(row.children).filter(function (el) {
      return (el.classList && el.classList.contains('ip-pair-g')) || (el.tagName === 'SCRIPT' && el.classList.contains('ip-pair-t'));
    });
  }

  /* 1. groups follow the pick */
  function sizeFits(g, sz) {
    if (!g.hasAttribute('data-ip-size')) return true;
    var raw = g.getAttribute('data-ip-size') || '';
    if (sz === '') return raw === '';
    if (raw === '') return false;
    return raw.split('|').map(norm).indexOf(sz) > -1;
  }
  function setVariant(g, sz) {
    var inp = g.querySelector('input[data-ip-vmap]');
    if (!inp || sz === '') return;
    (inp.getAttribute('data-ip-vmap') || '').split('|').forEach(function (it) {
      var x = it.split(':');
      if (x.length < 3 || norm(x[0]) !== sz) return;
      inp.value = x[1];
      var a = g.querySelector('.mk-fbt-tiles [data-ip-item]');
      if (a) a.setAttribute('data-ip-price', x[2]);
    });
    [].slice.call(g.querySelectorAll('[data-ip-szp]')).forEach(function (s) { s.hidden = norm(s.getAttribute('data-ip-szp')) !== sz; });
  }
  /* a waiting group is built in place of its template and brought up to the page's state */
  function materialize(t, row) {
    var box = document.createElement('div');
    box.innerHTML = t.textContent || t.text || '';
    var g = box.querySelector('.ip-pair-g');
    if (!g || !t.parentNode) return null;
    t.parentNode.replaceChild(g, t);
    var d = window.ipVariant || {};
    if (d.id) [].forEach.call(g.querySelectorAll('[data-chain]'), function (i) { i.value = d.id; });
    var pr = document.getElementById('price');
    if (pr && pr.textContent) [].forEach.call(g.querySelectorAll('.mk-fbtp'), function (e) { e.textContent = pr.textContent.replace(/^\s+|\s+$/g, ''); });
    if (d.id && d.available === false) [].forEach.call(g.querySelectorAll('form.both button'), function (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); });
    bindGroup(g, row);
    return g;
  }
  function apply(d) {
    if (!d) return;
    var col = norm(d.color), sz = norm(d.size);
    rows.forEach(function (row) {
      var gs = slots(row);
      if (!gs.length) return;
      var sized = gs.some(function (g) { return g.hasAttribute('data-ip-size'); });
      var colours = {};
      gs.forEach(function (g) { colours[g.getAttribute('data-ip-color') || ''] = 1; });
      var oneColour = Object.keys(colours).length === 1;
      var pick = null;
      gs.forEach(function (g) {
        if (pick) return;
        var okC = oneColour || (g.getAttribute('data-ip-color') || '') === col;
        if (okC && (!sized || sizeFits(g, sz))) pick = g;
      });
      if (pick && pick.tagName === 'SCRIPT') pick = materialize(pick, row);
      slots(row).forEach(function (g) { if (g.tagName !== 'SCRIPT') g.hidden = g !== pick; });
      row.hidden = !pick;
      if (pick) setVariant(pick, sz);
    });
  }

  /* 2. row seen: once per row per page view, half of the visible group on screen */
  var seen = {};
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.intersectionRatio < 0.5) return;
        var g = en.target, row = rowOf(g);
        if (!row || row.hidden || g.hidden) return;
        var id = row.getAttribute('data-ip-row') || '';
        if (seen[id]) return;
        seen[id] = 1;
        var items = [].slice.call(g.querySelectorAll('[data-ip-item]')).map(itemOf);
        emit('view_item_list', payload(row, id, items));
      });
    }, { threshold: 0.5 });
  }

  /* 3. a tap on a card or the paired piece */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t && !t.closest) t = t.parentNode;
    var a = t && t.closest ? t.closest('[data-ip-item]') : null;
    if (!a) return;
    var row = rowOf(a), g = groupOf(a);
    if (!row || !g) return;
    var all = [].slice.call(g.querySelectorAll('[data-ip-item]'));
    if (a.classList && a.classList.contains('mk-pr')) pick(a);
    emit('select_item', withPick(payload(row, row.getAttribute('data-ip-row') || '', [itemOf(a, Math.max(0, all.indexOf(a)))]), a));
  });

  /* 3b. Sameera's picks (Dima's handler on his chain page, scoped to the row): the tapped pick is marked and swapped
     into the total, the pendant line and its link, the paired cart line and the set-price text. */
  function pick(b) {
    var tiles = b.closest('.mk-fbt-tiles'), sec = b.closest('.mk-fbt');
    if (!tiles || !sec) return;
    [].slice.call(tiles.querySelectorAll('.mk-pr')).forEach(function (x) {
      var on = x === b;
      x.classList.toggle('on', on);
      x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    [].forEach.call(sec.querySelectorAll('[data-pr-name]'), function (e) { e.textContent = b.getAttribute('data-n'); });
    [].forEach.call(sec.querySelectorAll('[data-pr-price]'), function (e) { e.textContent = b.getAttribute('data-pr'); });
    var lk = sec.querySelector('[data-pr-link]');
    if (lk) lk.href = b.getAttribute('data-u');
    var id = sec.querySelector('[data-pr-id]');
    if (id) id.value = b.getAttribute('data-v');
    var sms = sec.querySelector('a[data-t="setprice"]');
    if (sms) {
      var o = sms.getAttribute('data-tt'), n = b.getAttribute('data-tt');
      if (o && n && o !== n) { sms.href = sms.href.split(o).join(n); sms.setAttribute('data-tt', n); }
    }
  }

  /* 4. Add both: keep _rec on the paired line (the live checkbox code renames the id inputs), count it, and post
     the pair here with each line's properties. The theme's product-form.js multi-add sends only id and quantity, so
     through it the paired line lost _rec, and its preventDefault ran before a document listener could count the tap
     (integrate, 2026-10-08). This listener sits on the form itself and is added before product-form.js enhances the
     form (this file is deferred and runs first), so it runs after the page's own check (size picked, not already
     adding; the page listens on #pdp-b in the capture phase, so it also covers a group built later) and before
     product-form.js, which then sees defaultPrevented and stays out. Success and error states copy product-form.js.
     With no cart manager the browser posts the form as it is, properties included.
     W2-fix: ':add_both' only when both pieces are ticked; the paired piece alone (this item unticked) is ':add_one';
     this item alone sends no row event (it is not an add from the row). */
  function syncRec(form) {
    var rec = form.querySelector('input[name$="[properties][_rec]"]');
    if (!rec) return null;
    var ids = [].slice.call(form.querySelectorAll('input[name$="[id]"]'));
    var paired = ids[1];
    if (!paired) return null;
    rec.disabled = !!paired.disabled;
    if (!paired.disabled) rec.name = paired.name.replace(/\[id\]$/, '[properties][_rec]');
    return paired.disabled ? null : paired;
  }
  function setLabel(btn, text) { if (btn) btn.textContent = text; }
  function settle(btn, was, ms) {
    setTimeout(function () { if (btn) { btn.disabled = false; btn.style.backgroundColor = ''; } setLabel(btn, was); }, ms);
  }
  function addBoth(form, row, e) {
    if (e.defaultPrevented) return;
    var g = groupOf(form);
    if (!g) return;
    if (syncRec(form)) {
      var ids = [].slice.call(form.querySelectorAll('input[name$="[id]"]'));
      var both = !!(ids[0] && !ids[0].disabled);
      var a = g.querySelector('.mk-fbt-tiles .mk-pr.on[data-ip-item]') || g.querySelector('.mk-fbt-tiles [data-ip-item]');
      if (a) emit('select_item', withPick(payload(row, (row.getAttribute('data-ip-row') || '') + (both ? ':add_both' : ':add_one'), [itemOf(a, 0)]), a));
    }
    var cm = window.cartManager;
    if (!cm || typeof cm.addMultipleToCart !== 'function' || typeof FormData === 'undefined') return;
    var fd = new FormData(form), items = [];
    for (var i = 0; fd.get('items[' + i + '][id]'); i++) {
      var it = { id: fd.get('items[' + i + '][id]'), quantity: parseInt(fd.get('items[' + i + '][quantity]'), 10) || 1 };
      var rec = fd.get('items[' + i + '][properties][_rec]');
      if (rec) it.properties = { _rec: rec };
      items.push(it);
    }
    if (!items.length) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var was = (btn && (btn.dataset.was || btn.dataset.originalText)) || 'Add both to cart';
    if (btn) btn.disabled = true;
    setLabel(btn, 'Adding...');
    Promise.resolve(cm.addMultipleToCart(items)).then(function (r) {
      if (!r || !r.success) throw new Error((r && r.error) || 'Failed to add to cart');
      setLabel(btn, 'Added!');
      if (btn) btn.style.backgroundColor = '#16a34a';
      if (window.cartUI && window.cartUI.showSuccessNotification) window.cartUI.showSuccessNotification(items.length + (items.length > 1 ? ' items' : ' item') + ' added to cart!');
      if (window.cartDrawer && window.cartDrawer.openDrawer) window.cartDrawer.openDrawer();
      settle(btn, was, 2000);
    }).catch(function (err) {
      setLabel(btn, 'Error - Try Again');
      if (btn) btn.style.backgroundColor = '#dc2626';
      if (window.cartUI && window.cartUI.showErrorNotification) window.cartUI.showErrorNotification((err && err.message) || 'Failed to add item to cart');
      settle(btn, was, 3000);
    });
  }
  /* a built group's checkboxes: the page's own checkbox code (it listens on #pdp-b for every .mk-fbt-sum) renames and
     disables the id inputs; _rec follows a tick later, as on the groups that were in the page from the start */
  function bindGroup(g, row) {
    [].slice.call(g.querySelectorAll('form.both')).forEach(function (form) {
      [].slice.call(form.parentNode.querySelectorAll('input[data-ck]')).forEach(function (ck) {
        ck.addEventListener('change', function () { setTimeout(function () { syncRec(form); }, 0); });
      });
      form.addEventListener('submit', function (e) { addBoth(form, row, e); });
    });
    if (io) io.observe(g);
  }
  rows.forEach(function (row) {
    slots(row).forEach(function (g) { if (g.tagName !== 'SCRIPT') bindGroup(g, row); });
  });
  document.addEventListener('ip:variant', function (e) { apply(e && e.detail); });
  apply(window.ipVariant);
})();
